import React from "react";
import { Row } from "react-bootstrap";
import { DropDownButton } from "@progress/kendo-react-buttons";
import SingleCheckExcelExportWrapper from "../../../../components/export/SingleCheckExcelExportWrapper";
import SingleCheckPdfExportWrapper from "../../../../components/export/SingleCheckPdfExportWrapper";

export const RemittanceLookupActionCell = (props) => {
  const { dataItem, onViewHistory, onEditManualRemittance, onArchive, onRestorePending, oktaAuth } = props;
  const [isLoading, setIsLoading] = React.useState(false);

  const viewButtonItems = ["History", "Excel", "PDF"];

  const actionButtonItemsForArchivedChecks = ["Restore Pending"];
  const actionButtonItemsForPendingChecks = ["Archive this Record"];

  async function viewClick(event) {
    if (event.item === "History" && onViewHistory) {
      await onViewHistory(dataItem.pmid);
    }
    const accessToken = oktaAuth.getAccessToken();
    if (event.item === "Excel") {
      await SingleCheckExcelExportWrapper(
        dataItem.pmid,
        accessToken,
        setIsLoading
      );
    } else if (event.item === "PDF") {
      await SingleCheckPdfExportWrapper(
        dataItem.pmid,
        accessToken,
        setIsLoading
      );
    }
  }

  async function pendingOrArchiveClick(event) {
    if (event.item === "Archive this Record" && onArchive) {
      await onArchive(dataItem.pmid);
    } else if (event.item === "Restore Pending" && onRestorePending) {
      await onRestorePending(dataItem.pmid);
    } else if (event.item === "Edit" && onEditManualRemittance) {
      await onEditManualRemittance(dataItem.pmid);
    }
  }

  let actionButtons = [];
  if (dataItem.status === "Archived") {
    actionButtons.push(...actionButtonItemsForArchivedChecks);
  } else {
    actionButtons.push(...actionButtonItemsForPendingChecks);
  }

  if (dataItem.isManualCheck) {
    actionButtons.push("Edit");
  }

  return (
    <td className="noPadding" {...props.style}>
      <Row>
        <div className="col-sm-5 p-0">
          <DropDownButton
            text="View"
            items={viewButtonItems}
            onItemClick={viewClick}
            themeColor={"primary"}
            fillMode={"link"}
          />
        </div>
        <div className="col-sm-5 p-0">
          <DropDownButton
            text="Action"
            items={actionButtons}
            onItemClick={pendingOrArchiveClick}
            themeColor={"primary"}
            fillMode={"link"}
          />
        </div>
      </Row>
    </td>
  );
};
